import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import translations
import en from '../locales/en.json'
import es from '../locales/es.json'

// Get saved language from localStorage
const getSavedLanguage = (): string => {
  try {
    const savedLang = localStorage.getItem('user_language')
    return savedLang && ['en', 'es'].includes(savedLang) ? savedLang : 'es'
  } catch (error) {
    // If localStorage is not available (SSR), return default
    return 'es'
  }
}

// Configure i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
    },
    lng: getSavedLanguage(), // Load saved language or default to 'es'
    fallbackLng: 'es', // Fallback language
    interpolation: {
      escapeValue: false // React already escapes values
    },
    debug: import.meta.env.DEV // Enable debug in development
  })

export default i18n
